export const AijMedicamentos = () => {

    const list = [
        [
            // Subtipos
            [
                'Sistêmica sem manifestação ativa e com poliartrite',
            ],
            [
                // Primeira opção
                [
                    'Prednisona',
                    'Tocilizumabe',
                ],
                // Segunda opção
                [
                    'Metotrexato',
                    'Etanercepte',
                    'Adalimumabe',
                    'Abatacepte',
                ],
                // Terceira opção
                [
                    '',
                ],
                // Quarta opção
                [
                    '',
                ],
            ]
        ],
        [
            // Subtipos
            [
                'Sistêmica com manifestação ativa com ou sem artrite',
            ],
            [
                // Primeira opção
                [
                    'Prednisona',
                ],
                // Segunda opção
                [
                    'Tocilizumabe',
                ],
                // Terceira opção
                [
                    'Etanercepte',
                    'Adalimumabe',
                    'Abatacepte',
                    'Infliximabe',
                ],
                // Quarta opção
                [
                    '',
                ],
            ]
        ],
        [
            // Subtipos
            [
                'Oligoartrite',
            ],
            [
                // Primeira opção
                [
                    'Prednisona',
                    'Naproxeno',
                ],
                // Segunda opção
                [
                    'Metotrexato',
                ],
                // Terceira opção
                [
                    'Etanercepte',
                    'Adalimumabe',
                    'Infliximabe',
                    'Abatacepte',
                ],
                // Quarta opção
                [
                    'Abatacepte',
                    'Tocilizumabe',
                ],
            ]
        ],
        [
            // Subtipos
            [
                'Poliarticular',
            ],
            [
                // Primeira opção
                [
                    'Prednisona',
                    'Naproxeno',
                    'Metotrexato',
                ],
                // Segunda opção
                [
                    'Leflunomida',
                ],
                // Terceira opção
                [
                    'Etanercepte',
                    'Adalimumabe',
                    'Abatacepte',
                    'Infliximabe',
                ],
                // Quarta opção
                [
                    'Etanercepte',
                    'Adalimumabe',
                    'Infliximabe',
                    'Abatacepte',
                    'Tocilizumabe',
                ],
            ]
        ],
        [
            // Subtipos
            [
                'Artrite com entesite',
            ],
            [
                // Primeira opção
                [
                    'Prednisona',
                    'Naproxeno',
                ],
                // Segunda opção
                [
                    'Metotrexato',
                    'Sulfassalazina',
                ],
                // Terceira opção
                [
                    'Etanercepte',
                    'Adalimumabe',
                    'Infliximabe',
                ],
                // Quarta opção
                [
                    'Etanercepte',
                    'Adalimumabe',
                    'Infliximabe',
                ],
            ]
        ],
        [
            // Subtipos
            [
                'Artrite psoríaca',
            ],
            [
                // Primeira opção
                [
                    'Prednisona',
                    'Naproxeno',
                ],
                // Segunda opção
                [
                    'Metotrexato',
                    'Sulfassalazina',
                ],
                // Terceira opção
                [
                    'Etanercepte',
                    'Adalimumabe',
                    'Infliximabe',
                    'Abatacepte',
                ],
                // Quarta opção
                [
                    '',
                ],
            ]
        ],
    ]

    return list
}